import React, { FC } from 'react';
import { Box, Modal, ModalSize } from '@lifechurch/react-ion';
import { ServiceDataMoment } from '../Analytics/Service/AnalyticsServiceGrid';
import { TableBody } from '../Analytics/Service/AnalyticsServiceMomentEngagement/TableBody';
import { TableHeader } from '../Analytics/Service/AnalyticsServiceMomentEngagement/TableHeader';

interface Props {
  moments: ServiceDataMoment[];
  dismiss: () => void;
}

const AnalyticsServiceMomentsModal: FC<Props> = ({ dismiss, moments }) => {
  return (
    <Modal dismiss={dismiss} open={true} size={ModalSize.WIDE}>
      <Box
        backgroundColor='white'
        borderRadius={2}
        data-testid='modal-container'
        marginBlockStart={5}
        paddingBlockEnd={5}
        paddingBlockStart={5}
        px={5}
      >
        <TableHeader />
        <TableBody moments={moments} />
      </Box>
    </Modal>
  );
};

export default AnalyticsServiceMomentsModal;
